import Routers from "./Routers";
import './Styles/Style.css';

function App() {
  return (
    <Routers />
  );
}

export default App;
